import angular from 'angular'

import { merge } from 'lodash-es'
import { defaultTo } from '../utils/bits'
import { getElmStr } from '../utils/get-elm-str'
import { toSrc, isSrc } from '../utils/security'

import envRaw from '../utils/env-raw'
import StrictObj from '../utils/strict-obj'
import attachGetters from '../utils/attach-getters'
import attachSetters from '../utils/attach-setters'

import Template from './gallery-root.component.ejs'

angular
  .module('ggs')
  .component('ggsRoot', {
    template: Template(StrictObj({
      LE: envRaw.liveEditMode
    })),
    controller: RootComponent
  })

function RootComponent(
  $q,
  $scope,
  qh,
  env,
  locale,
  timeago,
  debugObj,
  imgQueue,
  galleryRpc,
  Properties,
  $rootElement,
  DefineMethod,
  DefineHandler,
  TryUseBootstrap) {

  const sign = 'root'
  const $ctrl = $scope.$ctrl = debugObj(sign, attachGetters(attachSetters(StrictObj(this))))

  $ctrl.wrapM = DefineMethod(sign)
  $ctrl.wrapH = DefineHandler(sign)

  $ctrl.bootstrap = undefined
  $ctrl.mainReady = false
  $ctrl.showsOverlay = $ctrl.getters.negate.mainReady

  $ctrl.wrapM('mainReadyCallback',
    $ctrl.setters.bindTrue.mainReady)

  $ctrl.wrapM('getRealBootstrap',
    TryUseBootstrap('bootstrapData', () => {
      return galleryRpc.getBootstrapData(
        env.props.galleryKey,
        env.props.initOrderType,
        env.props.sharedPostKey)
    }))

  $ctrl.wrapM('useFakeServer', () => {
    console.info(`gallery configuration cannot be loaded because of incorrect gallery key, connection issue, or server failure ${getElmStr($rootElement)}`)
    return galleryRpc
      .$$enableFakeServer()
      .$$getFakeBootstrap()
  })

  $ctrl.wrapM('initializeBootstrap', (bootstrap) => {
    merge(bootstrap.properties, envRaw.properties)
    bootstrap.properties = Properties(bootstrap.properties)
    bootstrap.top_posts = defaultTo(bootstrap.top_posts, [])
    bootstrap.displayed_item = defaultTo(bootstrap.displayed_item, null)
    env.props.lockRead()
    return StrictObj(bootstrap)
  })

  $ctrl.wrapM('preloadImages', (bootstrap) => {
    const images = [
      bootstrap.properties.logo,
      bootstrap.properties.image,
      bootstrap.properties.body_background_image
    ]
    const urls = images.map(toSrc).filter(isSrc)
    return $q.all(urls.map(qh.makeAttempt(imgQueue.stayInQueue)))
  })

  $ctrl.wrapM('setupLocale', (bootstrap) => {
    return locale.setup(
      bootstrap.properties.key2get.locale,
      bootstrap.properties.key2emitter.locale)
  })

  $ctrl.wrapM('setupTimeago', () => {
    return timeago.setup(
      locale.fromTime,
      locale.emitter)
  })

  $ctrl.wrapM('assignBootstrap', (bootstrap) => {
    $ctrl.bootstrap = bootstrap
  })

  $ctrl.wrapH('$onInit',
    qh.makeFlow(
      qh.makeCatch(
        $ctrl.getRealBootstrap,
        $ctrl.useFakeServer),
      $ctrl.initializeBootstrap,
      qh.makeOver(
        qh.makeJoin(
          qh.makeOver(
            $ctrl.setupLocale,
            $ctrl.setupTimeago),
          $ctrl.preloadImages),
        $ctrl.assignBootstrap)))
}
